const common = {
  Save: 'Save',
  Add: 'Add',
  Copy: 'Copy',
  'Copied to clipboard': 'Copied to clipboard',
  'Something went wrong. Please try again.':
    'Something went wrong. Please try again.',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  Close: 'Close',
  Logout: 'Logout',
  'Upgrade now': 'Upgrade now',
};

export default common;
